import React from 'react'
import {
  useCurrentOrganization,
  useCurrentUser,
  useSplitClient
} from 'contrastBase/state'
import { SelectSensorDialog } from '../../../components/add-sensor-wizard/select-sensor-dialog'
import { createNgReactBridgeDirective } from '../../react-bridge'
import { compose } from '../../../util'
import { injectIntl } from 'react-intl'
import { useAvailableAgents } from '../../../components/add-agent/api/use-available-agents'
import { SelectSensorType } from '../../../components/add-sensor-wizard/select-sensor-type'
import {
  getRbacStatus,
  userHasResourceAction
} from 'contrastBase/accessControl'
import { getMostPermissiveRole } from '../../../components/roles'
import { Action } from '@contrast-security-inc/base-types'

export const SelectSensorWizard = ({
  isServerlessEnabled // there's no current way to figure this out on the react side!
}: {
  isServerlessEnabled?: boolean
}) => {
  const { currentOrganization } = useCurrentOrganization()
  const { isSplitTreatmentOn } = useSplitClient()
  const { organizationUuid, isHarmonyEnabled } = currentOrganization || {}
  const { currentUser } = useCurrentUser()
  const role = getMostPermissiveRole(currentUser?.roles || [])

  const isProjectReposAuthorized = isSplitTreatmentOn('SCA-1768_rbac')
    ? userHasResourceAction(
        'ORG_SETTINGS',
        'SCA_PROJECT_GROUP_CREATE' as unknown as Action
      )
    : true

  const isProjectReposEnabled =
    isSplitTreatmentOn('PROD-2340_SIR_Projects_Tab') &&
    isSplitTreatmentOn('PROD-2175_GitHub_App_Repo_Table') &&
    (!isSplitTreatmentOn('PROD-2918_hide_sca_data_unless_org_admin') ||
      role === 'ADMIN') &&
    isProjectReposAuthorized
  const { enabled, isScanEnforced, isAssessEnforced } = getRbacStatus()
  const hasEditOrgSettings = userHasResourceAction('ORG_SETTINGS', 'EDIT')
  const sastProjectCreatePermission = userHasResourceAction(
    'RESOURCE_GROUP',
    'RESOURCE_GROUP_PROJECT_CREATE'
  )

  const displayScanSensor =
    !!isHarmonyEnabled &&
    (enabled && isScanEnforced ? sastProjectCreatePermission : true)

  const organizationId = organizationUuid as string

  const { availableAgents } = useAvailableAgents({
    organizationUuid: organizationId,
    enabled: !!organizationId
  })

  const displayAgentSensor =
    availableAgents?.length > 0 &&
    (enabled && isAssessEnforced ? hasEditOrgSettings : true)

  return (
    <SelectSensorDialog onClose={() => window.history.back()}>
      <SelectSensorType
        organizationId={organizationId}
        isProjectReposEnabled={isProjectReposEnabled}
        isHarmonyEnabled={displayScanSensor}
        isServerlessEnabled={!!isServerlessEnabled}
        isAgentEnabled={displayAgentSensor}
      />
    </SelectSensorDialog>
  )
}

export const reactSelectSensorWizard = createNgReactBridgeDirective(
  'reactSelectSensorWizard',
  [],
  compose(injectIntl)(SelectSensorWizard),
  ['isServerlessEnabled'] // We haven't developed the React API yet to request the /users/access API so need to pass it through from angular
)
